var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-container" },
    [
      _c("CreateCampaignForm", {
        attrs: { "show-loader": _vm.isCreationPending },
        on: {
          save: function($event) {
            return _vm.onSave($event)
          },
          dismiss: function($event) {
            return _vm.dismissForm()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }